import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  Achievements,
  AchievementsRequest,
  AchievementsResponse,
} from './types'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const achievementsMounted = createEvent<AchievementsRequest>()

export const getAchievements = fx<AchievementsRequest, AchievementsResponse>({
  method: 'GET',
  url: `/achievement`,
})

export const $achievements = restore<Achievements[]>(
  getAchievements.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfAchievements = restore(
  getAchievements.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: achievementsMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    let newObj = {}

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getAchievements,
})
